<template>
  <q-layout view="lHh lpR fFf" class="app-layout">
    <q-header class="app-header">
      <q-toolbar class="app-toolbar">
        <q-btn
          flat
          dense
          icon="menu"
          @click="toggleDrawer"
          class="app-navigation-toggle"
        />
        <q-toolbar-title>
          <h5 class="text-h5 q-my-none custom-title q-pl-xs">
            WG - 2SG Wholesale <sup class="text-caption">v1.0</sup>
          </h5>
        </q-toolbar-title>
      </q-toolbar>
    </q-header>

    <q-drawer
      show-if-above
      v-model="drawer"
      side="left"
      class="bg-accent text-white fixed"
      :width="200"
    >
      <q-list>
        <navigation-item-wrapper
          v-for="(route, index) in routes"
          :key="index"
          v-bind="route"
        />
      </q-list>
    </q-drawer>

    <q-page-container>
      <!-- <div class="row q-pa-md app-page-detail">
        <div class="col-md-12">
          <h5 class="text-h5 q-my-none">
            WG - 2SG Wholesale <sup class="text-caption">v1.0</sup>
          </h5>
        </div>
      </div> -->

      <main class="app-main app-page-detail">
        <router-view />
        <!-- <button @click="getWholesaler">Test</button> -->
      </main>
    </q-page-container>
  </q-layout>
</template>

<script lang="ts">
import { ref } from 'vue'
import NavigationItemWrapper from './components/iterables/NavigationItemWrapper.vue'
import HttpClient from './services/HttpClient'
const HTTP = new HttpClient('')

export default {
  components: {
    NavigationItemWrapper
  },
  setup() {
    const drawer = ref(false)

    const getWholesaler = () => {
      console.log('test')
    }

    const routes = [
      // {
      //   path: '/',
      //   text: 'Go Wireless',
      //   icon: 'wifi'
      // },
      // {
      //   path: '/mobile-voice',
      //   text: 'Mobile Voice',
      //   icon: 'phonelink_ring'
      // },
      {
        path: '/',
        text: 'Service List',
        icon: 'search'
      },
      {
        path: '/orders-list',
        text: 'Orders List',
        icon: 'format_list_numbered'
      },
      {
        path: '/activate',
        text: 'Activate',
        icon: 'flip_camera_android'
      },
      {
        path: '/port-out',
        text: 'Port Out',
        icon: 'assignment'
      },
      {
        path: '/port-in',
        text: 'Port In',
        icon: 'fact_check'
      },
      {
        path: '/drop-ship',
        text: 'Drop Ship',
        icon: 'local_shipping'
      },
      {
        path: '/coverage',
        text: 'Coverage',
        icon: 'travel_explore'
      },
      {
        text: 'Admin',
        icon: 'admin_panel_settings',
        children: [
          {
            path: '/admin/clients',
            text: 'Clients',
            icon: 'group'
          },
          {
            path: '/admin/bearer',
            text: 'Bearer',
            icon: 'person'
          },
          {
            path: '/admin/go-wireless',
            text: 'GoWireless',
            icon: 'cell_wifi'
          },
          {
            path: '/admin/inventory',
            text: 'Inventory',
            icon: 'inventory_2'
          }
        ]
      }
    ]

    const toggleDrawer = () => {
      drawer.value = !drawer.value
    }

    return {
      drawer,
      routes,
      toggleDrawer,
      getWholesaler
    }
  }
}
</script>
<style scoped>
.custom-title {
  color: #676a6c;
}
</style>
